<script setup>
useHead({
  bodyAttrs: {
    class: 'bg-blurple-500',
  },
})
</script>

<template>
  <div class="flex flex-col min-h-screen bg-blurple-500">
    <ContentGrid as="header" class="w-full pt-xl pb-l">
      <NuxtLink aria-label="Hjem" :to="{ name: 'home' }" class="no-underline">
        <IconsLogoJuridika aria-hidden="true" class="fill-white h-full" />
      </NuxtLink>
    </ContentGrid>
    <slot name="header" />
    <main class="flex-1">
      <div class="px-s">
        <ContentGrid class="bg-white rounded-4xl">
          <slot />
        </ContentGrid>
      </div>
    </main>
    <Footer class="dark-mode" wide />
  </div>
</template>
